/**
 * Image Fallback Constants
 * 
 * Central location for image fallback assets used by SafeImage component
 * and useImageWithFallback hook
 */

/**
 * Inline SVG placeholder as data URI - guaranteed to work, no network request
 * Used as the final fallback when images fail to load
 * 
 * Features:
 * - Beautiful gradient background (indigo to purple)
 * - "Image Unavailable" text
 * - Decorative circles for visual interest
 * - No external dependencies
 */
export const FALLBACK_SVG_DATA_URI = 
  'data:image/svg+xml,%3Csvg width="400" height="300" xmlns="http://www.w3.org/2000/svg"%3E%3Cdefs%3E%3ClinearGradient id="grad" x1="0%25" y1="0%25" x2="100%25" y2="100%25"%3E%3Cstop offset="0%25" style="stop-color:%234f46e5;stop-opacity:1" /%3E%3Cstop offset="100%25" style="stop-color:%237c3aed;stop-opacity:1" /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width="400" height="300" fill="url(%23grad)"/%3E%3Crect x="20" y="20" width="360" height="260" fill="none" stroke="white" stroke-width="2" opacity="0.3"/%3E%3Ctext x="200" y="160" text-anchor="middle" fill="white" font-family="Arial, sans-serif" font-size="18" font-weight="bold"%3EImage Unavailable%3C/text%3E%3Ccircle cx="80" cy="60" r="20" fill="white" opacity="0.2"/%3E%3Ccircle cx="320" cy="240" r="15" fill="white" opacity="0.2"/%3E%3Ccircle cx="350" cy="50" r="10" fill="white" opacity="0.2"/%3E%3C/svg%3E';
